export default __webpack_public_path__ + "static/media/trustCredibility_icon.ee2305e3.webp";